import { render, staticRenderFns } from "./OfferPager.vue?vue&type=template&id=e986e870&"
import script from "./OfferPager.vue?vue&type=script&lang=js&"
export * from "./OfferPager.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports